import { ActionText } from '@components/action-text';

import { TravellerJourneyListItem } from 'api/types';

import { useCompanyTravellerSidebar } from '../../../company-travellers/sidebars/form';
import { t } from '../locale';

export const PhoneCell = ({ row: traveller }: { row: TravellerJourneyListItem }) => {
  const showEditCompanyTravellerSidebar = useCompanyTravellerSidebar();
  const hasPhone = Boolean(traveller.phone);
  return (
    <ActionText
      font="regular14"
      color={hasPhone ? 'textPrimary' : 'textHelper'}
      onClick={() => {
        showEditCompanyTravellerSidebar({
          companyTravellerShortId: traveller.companyTravellerShortId,
        });
      }}
    >
      {hasPhone ? traveller.phone : t('core.not_set')}
    </ActionText>
  );
};
